<template>
    <div class="dropMenuButton" ref="wrap">
        <icon-button :icon="icon" :size="size" ref="showMenu" @click="toggle" :tabindex="tabindex"
                @keydown="doKeyDown" :title="title" :aria="aria" :disabled="disabled" class="dropButton">
            <template>
                <slot name="icon"></slot>
            </template>
        </icon-button>
        <drop-menu v-if="menuShowed" :style="`top:${btnHeight}px`"
                v-click-outside="{ exclude: ['showMenu'], handler: 'clickedOutside'}"
                :options="options" :menuname="menuname"
                @select="doClick" :value="value"
                @hide="hide(false)">
            <template v-slot:default="{ row }">
                <slot name="row" v-bind:row="row"></slot>
            </template>
        </drop-menu>
    </div>
</template>

<script>
import DropMenu from '@/components/dropMenu';
import IconButton from '@/components/iconButton';

export default {
  name: 'DropMenuButton',
  components: { DropMenu, IconButton },
  data: function() {
    return {
      menuShowed: false,
      refocusComponent: null
    };
  },
  props: {
    icon: {
      type: [ String, Array ],
      required: false
    },
    size: {
      type: String,
      default: '1x'
    },
    title: String,
    aria: String,
    disabled: Boolean,
    // Array of {text:, value:, disabled: <bool>}
    options: Array,
    value: String,
    menuname: {
      type: String,
      required: true
    },
    triggerHide: Boolean,
    tabindex: {
      type: [ Number, String ],
      default: 0
    }
  },
  watch: {
    triggerHide(newVal) {
      if (newVal) {
        this.hide();
      }
    }
  },
  methods: {
    toggle() {
      if (this.menuShowed) {
        this.hide();
      } else {
        this.show();
      }
    },
    show() {
      this.menuShowed = true;
      this.$emit('show');
    },
    clickedOutside() {
      this.hide(true);
    },
    hide(clickoutside) {
      console.log('called hide', clickoutside);
      this.menuShowed = false;
      if (this.refocusComponent) {
        this.refocusComponent.reFocus();
        this.refocusComponent = null;
      } else if (!clickoutside) {
        console.log('focus button');
        this.$refs.showMenu.focus();
      }
      this.$emit('hide', clickoutside);
    },
    doKeyDown(evt) {
      if (!this.menuShowed && evt.key === 'ArrowDown') {
        this.show();
      }
    },
    doClick(evt) {
      console.log('menu clicked', evt);
      this.$emit('menu', evt);
      this.hide(false);
    },
    onToolbarAction(action, tb) {
      if (!this.menuShowed && ((action === ' ') || (action === 'Enter') || action === 'ArrowDown')) {
        this.toggle();
        if (this.menuShowed) {
          this.refocusComponent = tb;
        }
        return true;
      } else if (this.menuShowed && ((action === 'ArrowUp') || (action === 'Escape'))) {
        this.hide(false);
        return true;
      } else if (action === 'hide') {
        this.hide(false);
      }
      return false;
    }
  },
  computed: {
    btnHeight() {
      return this.$refs.wrap.offsetHeight;
    }
  }
};
</script>

<style scoped lang="scss">
    .dropMenuButton {
        position:relative;
        display: inline-block;
    }
    .dropButton {
        // margin-left: 0;
    }

</style>
